module.exports = __webpack_public_path__ + "static/media/youtube.3353438a.svg";